import { useCallback, useState } from "react";

export const useRerenderTrigger = () => {
  const [, setCount] = useState(0);

  return useCallback(() => setCount((prevCount) => prevCount + 1), []);
};
